import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AccordionModule} from 'primeng/accordion';
import { TableModule} from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { MessagesModule } from 'primeng/messages';

import { UpdateAgendaComponent } from './update-agenda.component';
import { ViewAgendaComponent } from './view-agenda.component';
import { LoginRouteGuard } from 'src/app/login-route-guard';
import { AgendaSummaryComponent } from "./agenda-summary.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AccordionModule,
    TableModule,
    ToastModule,
    ConfirmDialogModule,
    CalendarModule,
    MessagesModule,
    // ProgressSpinnerModule,
    RouterModule.forChild([
      { path: 'updateagenda', component: UpdateAgendaComponent, canActivate: [LoginRouteGuard] },
      { path: 'viewagenda', component: ViewAgendaComponent, canActivate: [LoginRouteGuard]},
      { path: 'agendasummary', component: AgendaSummaryComponent, canActivate: [LoginRouteGuard]},
      { path: '', redirectTo: 'home', pathMatch: 'full'},
    ]),

  ],
  declarations: [
    UpdateAgendaComponent,
    ViewAgendaComponent,
    AgendaSummaryComponent
  ],
  providers: [
    MessageService,
    ConfirmationService,
  ]
})

export class AgendaModule {
 }
